<template>
  <div id="hrms6ke">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchParams"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms6keIndex"
            searchBoxAlias="request-subrogate"
            :addEvent="addEvent"
            :editEvent="editEvent"
            :deleteInlineEventBool="true"
            :deleteInlineBtnDisp="false"
            :saveInlineEvent="callDelete" />

    <detail v-if="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :detail="detail"
            :currentDtereq="currentDtereq"
            :currentNumseq="detail.numseq"
            :currentCodempid="codempid"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :eventBtn="eventBtn"
            :postHrms6keSave="postHrms6keSave"
            :indexSelected="indexSelected"
            :arrCodrem="dropdowns.codrem"
            :descCodapp="dash.descCodapp"
            :detailTab2Table="columns[app.nowLang].detailTab2Table"
            :receivedHrms6keDetailTab2Process="receivedHrms6keDetailTab2Process"
            :receivedHrms6keDetailTab2ProcessCodempid="receivedHrms6keDetailTab2ProcessCodempid"
            :receivedHrms6keDetailAddInline="receivedHrms6keDetailAddInline"
            :detailTab2InlineData="detailTab2InlineData"
            :searchIndex="searchParams"
            :setDetailInlineData="setDetailInlineData" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms6ke/mutation-types'
import detail from 'components/hrms6ke/detail'
import moment from 'moment'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms6ke',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      dash: this.$parent.$parent.$parent.$children[0],
      currentDtereq: moment().format('DD/MM/YYYY'),
      eventBtn: '',
      searchDetail: {
        numotgen: ''
      },
      searchParams: {
        codcomp: '',
        codempid: '',
        dtereqst: '01/' + moment().format('MM/YYYY'),
        dtereqen: moment().format('DD/MM/YYYY')
      }
    }
  },
  created () {
    this.receivedHrms6keColumnsLabels()
    this.receivedHrms6keDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS6KE_INDEX_DISP,
      detailDisp: types.GET_HRMS6KE_DETAIL_DISP,
      columns: types.GET_HRMS6KE_COLUMNS,
      labels: types.GET_HRMS6KE_LABELS,
      index: types.GET_HRMS6KE_INDEX,
      indexSelected: types.GET_HRMS6KE_INDEX_SELECTED,
      detail: types.GET_HRMS6KE_DETAIL,
      dropdowns: types.GET_HRMS6KE_DROPDOWNS,
      detailTab2InlineData: types.GET_HRMS6KE_DETAIL_INLINE_DATA
    })
  },
  methods: {
    pageDetail (event, param) {
      switch (event) {
        case 'add':
          this.setIndexSelected({})
          this.searchDetail.numotgen = ''
          this.eventBtn = 'add'
          this.receivedHrms6keCreate(this.searchDetail)
          this.currentDtereq = moment().format('DD/MM/YYYY')
          this.toggle('detail')
          break
        case 'edit':
          if (param.numotgen) {
            if (param.staappr === 'A' || param.staappr === 'Y' || param.staappr === 'N') {
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                confirmButtonText: constLabels('ok')
              })
            }
            this.searchDetail.numotgen = param.numotgen
            this.eventBtn = 'edit'
            this.receivedHrms6keDetail(param)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    addEvent (param) {
      this.pageDetail('add', param)
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit', param)
    },
    callDelete (dataRowsHasFlg) {
      if (dataRowsHasFlg.length > 0) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.postHrms6keDelete({ saveParams: dataRowsHasFlg, searchParams: this.searchParams })
          }
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS6KE_INDEX_SELECTED,
      setDetailInlineData: types.SET_HRMS6KE_DETAIL_INLINE_DATA
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS6KE_PAGE,
      receivedHrms6keColumnsLabels: types.RECEIVED_HRMS6KE_COLUMNS_LABELS,
      receivedHrms6keDropdowns: types.RECEIVED_HRMS6KE_DROPDOWNS,
      receivedHrms6keIndex: types.RECEIVED_HRMS6KE_INDEX,
      receivedHrms6keCreate: types.RECEIVED_HRMS6KE_CREATE,
      receivedHrms6keDetail: types.RECEIVED_HRMS6KE_DETAIL,
      postHrms6keSave: types.POST_HRMS6KE_SAVE,
      postHrms6keDelete: types.POST_HRMS6KE_DELETE,
      receivedHrms6keDetailTab2Process: types.RECEIVED_HRMS6KE_DETAIL_TAB2_PROCESS,
      receivedHrms6keDetailTab2ProcessCodempid: types.RECEIVED_HRMS6KE_DETAIL_TAB2_PROCESS_CODEMPID,
      receivedHrms6keDetailAddInline: types.RECEIVED_HRMS6KE_DETAIL_ADD_INLINE
    })
  },
  components: {
    detail
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?058cfd0f